import EcommField from "./EcommField";
import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Stack, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { StoreContactSettings as Settings } from "../../models/order-crm.model";
import { orderCrmApi } from "../../services/order-crm.service";

export default function StoreContactSettings({ businessId }: { businessId: string }) {
  const [data, setData] = useState<Settings | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  useEffect(() => { let active = true; setData(null);
    orderCrmApi.storeContact(businessId).then(s => { if (active) setData(s); }).catch(() => { if (active) setError("Unable to load store contact settings."); });
    return () => { active = false; };
  }, [businessId]);
  const save = async () => { if (!data) return; setBusy(true); setError("");
    try { setData(await orderCrmApi.saveStoreContact(businessId, data)); setNotice("Store contact saved."); }
    catch { setError("Unable to save. Check your phone number and retry."); } finally { setBusy(false); }
  };
  return <Accordion><AccordionSummary expandIcon={<ExpandMore />}><Typography fontWeight={600}>Talk to store message</Typography></AccordionSummary><AccordionDetails><Stack spacing={2}>
    {error && <Alert severity="error">{error}</Alert>}{notice && <Alert severity="success">{notice}</Alert>}
    {data && <><EcommField label="Store phone with country code" value={data.phoneNumber} onChange={e => setData({ ...data, phoneNumber: e.target.value })} />
      {(["en", "hi", "te"] as const).map((language, i) => <EcommField key={language} label={`${["English", "Hindi", "Telugu"][i]} contact message`} multiline minRows={2} value={data.messages[language]} onChange={e => setData({ ...data, messages: { ...data.messages, [language]: e.target.value } })} />)}
      <Typography variant="body2">Use {'{phone}'} for the phone number and {'{whatsapp}'} for its WhatsApp link. Blank messages use the default store contact response.</Typography><Button disabled={busy} onClick={save}>Save store contact</Button></>}
  </Stack></AccordionDetails></Accordion>;
}
